import {Inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {SignUpFlow} from '../../enums/sign-up-flow';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';
import {AppConfigService} from '../../services/config.service';

const ACCEPTED_SIGN_UP_FLOWS: SignUpFlow[] = [
    SignUpFlow.SIGN_UP,
    SignUpFlow.SIGN_UP_AND_DEMO,
    SignUpFlow.SIGN_UP_WITHOUT_LINK
];

@Injectable()
export class SignUpPageGuard {

    constructor(
        private appConfigService: AppConfigService,
        private router: Router,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(): boolean | UrlTree {
        const singUpFlow: SignUpFlow = this.appConfigService.appConfig.signUpFlow;

        if (ACCEPTED_SIGN_UP_FLOWS.includes(singUpFlow)) {
            return true;
        } else {
            const url = this.routeRedirects.LOGIN_ROUTE;

            return this.router.parseUrl(url);
        }

    }
}
